// Application code known by the back-office API (table param.ApplicationMaintenance)
export const MAINTENANCE_APP_CODE = "espace-adherents";
export const MAINTENANCE_APP_CODE_HEADER = "X-App-Code";
export const MAINTENANCE_MESSAGE_STORAGE_KEY = "maintenanceMessage";
